module.exports = __webpack_public_path__ + "static/media/crmfitout.4eb10740.png";